import {
  FETCH_PARAMETERS_REQUEST,
  FETCH_PARAMETERS_SUCCESS,
  FETCH_PARAMETERS_ERROR,
  SAVE_PARAMETERS_REQUEST,
  SAVE_PARAMETERS_SUCCESS,
  SAVE_PARAMETERS_ERROR,

  FETCH_ADJUST_BY_STORE_REQUEST,
  FETCH_ADJUST_BY_STORE_SUCCESS,
  FETCH_ADJUST_BY_STORE_ERROR,
   SAVE_ADJUST_BY_STORE_REQUEST,
  SAVE_ADJUST_BY_STORE_SUCCESS,
  SAVE_ADJUST_BY_STORE_ERROR,
  RESET_ADJUST_BY_STORE,

  FETCH_IRC_AUTONOMOUS_PARAMETERS_REQUEST,
  FETCH_IRC_AUTONOMOUS_PARAMETERS_SUCCESS,
  FETCH_IRC_AUTONOMOUS_PARAMETERS_ERROR,
  SAVE_IRC_AUTONOMOUS_PARAMETERS_REQUEST,
  SAVE_IRC_AUTONOMOUS_PARAMETERS_SUCCESS,
  SAVE_IRC_AUTONOMOUS_PARAMETERS_ERROR,

} from 'actionTypes'

const DEFAULT_STATE = {
  get: {
    record: {},
    error: null,
    isFetching: false,
  },
  save: {
    isUpdating: false,
    error: null,
  },
  adjustByStore: {
    get: {
      record: {},
      error: null,
      isFetching: false,
    },
    save: {
      isUpdating: false,
      error: null,
    },
  },
}

const record = (state = DEFAULT_STATE, action) => {
  switch (action.type) {
    case FETCH_PARAMETERS_REQUEST:
      return {
        ...state,
        isFetching: true,
        error: null,
      }

    case FETCH_PARAMETERS_SUCCESS:
      return {
        ...state,
        get: {
          ...state.get,
          record: action.payload,
          isFetching: false,
          error: null,
        },
      }

    case FETCH_PARAMETERS_ERROR:
      return {
        ...state,
        get: {
          ...state.get,
          record: {},
          isFetching: false,
          error: action.payload,
        },
      }

    case SAVE_PARAMETERS_REQUEST:
      return {
        ...state,
        save: {
          ...state.save,
          isUpdating: true,
        },
      }

    case SAVE_PARAMETERS_SUCCESS:
      return {
        ...state,
        save: {
          ...state.save,
          isUpdating: false,
          error: null,
        },
        get: {
          ...state.get,
          error: null,
          isFetching: false,
          record: { ...action.payload },
        },
      }

    case SAVE_PARAMETERS_ERROR:
      return {
        ...state,
        save: {
          ...state.save,
          isUpdating: false,
          error: action.payload,
        },
      }

    case FETCH_ADJUST_BY_STORE_REQUEST:
      return {
        ...state,
        adjustByStore: {
          ...state.adjustByStore,
          get: {
            ...state.adjustByStore.get,
            isFetching: true,
            error: null,
          },
        },
      }

    case FETCH_ADJUST_BY_STORE_SUCCESS:
      return {
        ...state,
        adjustByStore: {
          ...state.adjustByStore,
          get: {
            ...state.adjustByStore.get,
            record: action.payload,
            isFetching: false,
            error: null,
          },
        },
      }

    case FETCH_ADJUST_BY_STORE_ERROR:
      return {
        ...state,
        adjustByStore: {
          ...state.adjustByStore,
          get: {
            ...state.adjustByStore.get,
            record: {},
            isFetching: false,
            error: action.payload,
          },
        },
      }

    case SAVE_ADJUST_BY_STORE_REQUEST:
      return {
        ...state,
        adjustByStore: {
          ...state.adjustByStore,
          save: {
            ...state.adjustByStore.save,
            isUpdating: true,
          },
        },
      }

    case SAVE_ADJUST_BY_STORE_SUCCESS:
      return {
        ...state,
        adjustByStore: {
          ...state.adjustByStore,
          save: {
            ...state.adjustByStore.save,
            isUpdating: false,
            error: null,
          },
          get: {
            ...state.adjustByStore.get,
            record: { ...action.payload },
            error: null,
            isFetching: false,
          },
        },
      }

    case SAVE_ADJUST_BY_STORE_ERROR:
      return {
        ...state,
        adjustByStore: {
          ...state.adjustByStore,
          save: {
            ...state.adjustByStore.save,
            isUpdating: false,
            error: action.payload,
          },
        },
      }
    
      case FETCH_IRC_AUTONOMOUS_PARAMETERS_REQUEST:
        return {
          ...state,
          get: { ...state.get, isFetching: true, error: null },
        };
  
      case FETCH_IRC_AUTONOMOUS_PARAMETERS_SUCCESS:
        return {
          ...state,
          get: { ...state.get, record: action.payload, isFetching: false, error: null },
        };
  
      case FETCH_IRC_AUTONOMOUS_PARAMETERS_ERROR:
        return {
          ...state,
          get: { ...state.get, error: action.payload, isFetching: false },
        };
  
      case SAVE_IRC_AUTONOMOUS_PARAMETERS_REQUEST:
        return {
          ...state,
          save: { ...state.save, isUpdating: true, error: null },
        };
  
      case SAVE_IRC_AUTONOMOUS_PARAMETERS_SUCCESS:
        return {
          ...state,
          get: { ...state.get, record: action.payload }, 
          save: { ...state.save, isUpdating: false, error: null },
        };
  
      case SAVE_IRC_AUTONOMOUS_PARAMETERS_ERROR:
        return {
          ...state,
          save: { ...state.save, error: action.payload, isUpdating: false },
        };

    case RESET_ADJUST_BY_STORE:
        return DEFAULT_STATE

    default:
      return state
  }
}

export default record
